export const SERVER_URL = 'https://api.prowebtrade.com';
// 'http://92.51.37.196:5000';
// 'http://localhost:5000'

// https://noxacrypto.com/backend
